import { invalidateUserQuery, queryKeyFn } from '@sit/client-shared';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { authStore } from '../redux/auth-store';

export function useUpdateAccessToken() {
  const queryClient = useQueryClient();
  return useCallback(
    (accessToken: string) => {
      authStore.setAccessToken(accessToken);
      return Promise.all([
        invalidateUserQuery(queryClient),
        queryClient.invalidateQueries({
          queryKey: queryKeyFn({
            path: '/companies',
            operationId: 'getApiCompany',
            variables: {},
          }),
        }),
      ]);
    },
    [queryClient],
  );
}
